module.exports = __webpack_public_path__ + "img/1266436.aca97a3b.svg";